module.exports = __webpack_public_path__ + "static/media/V-ID-3.dd77bfb7.mp4";